export class PlaceDropDown {

  public dentist: boolean;
  public gp: boolean;
  public province: string;
  public city: string;
  public suburb: string;

}
